import { FC } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { Button } from '../../atoms/Button'

type Props = {
  isSubmitting: boolean
  isOpenDropDown: boolean
  toggleDropDown: () => void
}

export const KeywordSearchGroupFormSearchButton: FC<Props> = observer(
  ({ isSubmitting, isOpenDropDown, toggleDropDown }) => {
    const { t } = useTranslation(['angels-vcs-startups'])
    return (
      <div className={styles.searchButtonContainer}>
        <div role='button' tabIndex={0} className={styles.advancedSearchButton} onMouseDown={() => toggleDropDown()}>
          <img
            src='/images/common/arrow_gray_icon.svg'
            className={classNames(styles.arrowIcon, { [styles.active]: isOpenDropDown })}
            alt={t('詳細検索条件')}
          />
          {t('詳細検索')}
        </div>
        <div>
          <Button disabled={isSubmitting} isLoading={isSubmitting} buttonSize='medium' buttonType='submit'>
            {t('検索する')}
          </Button>
        </div>
      </div>
    )
  }
)
